import styled, { createGlobalStyle } from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
  .admin-testimonials-page {
    .testimonials-area {
      padding: 70px 0;

      .card-box {
        background: #fff;
        border: 1px solid ${colors.border1};
        border-radius: 6px;
        box-shadow: 0 0 25px rgba(0, 0, 0, 0.08);
        padding: 30px;
        display: flex;
        flex-direction: column;
        gap: 20px;
      }

      .actions {
        display: flex;
        flex-direction: column;
        gap: 15px;

        button {
          width: fit-content;
          background: ${colors.red_bg};
          border: none;
          color: #fff;
          text-transform: uppercase;
          font-weight: 600;
          padding: 10px 22px;
          border-radius: 5px;
          &:hover {
            background: ${colors.red_bg2};
          }
        }

        .search-form {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          input {
            flex: 1;
            min-width: 240px;
            border: 1px solid ${colors.border3};
            border-radius: 4px;
            padding: 10px 12px;
            font-size: 14px;
          }

          button {
            padding: 10px 18px;
            border-radius: 4px;
            border: none;
            font-size: 14px;
            font-weight: 600;
            text-transform: uppercase;
            background: ${colors.red_bg};
            color: #fff;
            cursor: pointer;
            transition: background 0.2s ease;
            &:hover {
              background: ${colors.red_bg2};
            }
            &:disabled {
              opacity: 0.6;
              cursor: not-allowed;
              background: ${colors.border3};
              color: ${colors.text3};
            }
          }

          .clear-btn {
            background: transparent;
            color: ${colors.text3};
            border: 1px solid ${colors.border3};
            &:hover {
              color: #fff;
              background: ${colors.red};
              border-color: ${colors.red};
            }
            &:disabled {
              background: transparent;
              color: ${colors.text3};
              border-color: ${colors.border3};
            }
          }
        }

        .filter-controls {
          display: flex;
          align-items: center;
          gap: 10px;

          label {
            margin: 0;
            font-size: 14px;
            color: ${colors.text3};
          }

          select {
            border: 1px solid ${colors.border3};
            border-radius: 4px;
            padding: 8px 12px;
            font-size: 14px;
            min-width: 140px;
          }
        }
      }

      .data-grid {
        table {
          width: 100%;
          border-collapse: collapse;

          th,
          td {
            padding: 12px 14px;
            border: 1px solid ${colors.border3};
            vertical-align: middle;
            font-size: 14px;
          }

          th {
            background: ${colors.red_bg};
            color: #fff;
            text-transform: uppercase;
            font-weight: 600;
          }

          tbody tr:nth-child(odd) {
            background: #fafafa;
          }

          tbody tr:hover {
            background: rgba(0, 0, 0, 0.03);
          }
        }

        .author-cell {
          display: flex;
          align-items: center;
          gap: 12px;

          img {
            width: 56px;
            height: 56px;
            border-radius: 50%;
            object-fit: cover;
            border: 2px solid ${colors.border3};
          }

          .placeholder-avatar {
            width: 56px;
            height: 56px;
            border-radius: 50%;
            background: ${colors.red_bg};
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 700;
            font-size: 18px;
          }

          strong {
            display: block;
            color: ${colors.black1};
          }

          .muted {
            font-size: 12px;
            color: ${colors.text3};
          }
        }

        .actions-cell {
          display: flex;
          align-items: center;
          gap: 8px;

          .link-button {
            background: transparent;
            border: none;
            color: ${colors.red};
            text-decoration: underline;
            cursor: pointer;
            padding: 0;
            font-size: 14px;
            font-weight: 600;
            &:hover {
              color: ${colors.red2};
            }
            &.delete {
              color: ${colors.red};
              &:hover {
                color: #d13f3f;
              }
            }
            &:disabled {
              opacity: 0.6;
              cursor: not-allowed;
            }
          }

          .divider {
            color: ${colors.text3};
          }
        }

        .pagination-controls {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;
          gap: 15px;
          flex-wrap: wrap;

          .page-info {
            font-size: 14px;
            color: ${colors.text3};
          }

          .page-actions {
            display: flex;
            align-items: center;
            gap: 10px;

            button {
              padding: 8px 16px;
              border-radius: 4px;
              border: 1px solid ${colors.border3};
              background: ${colors.red_bg};
              color: #fff;
              font-size: 14px;
              font-weight: 600;
              transition: background 0.2s ease;
              &:hover {
                background: ${colors.red_bg2};
              }
              &:disabled {
                opacity: 0.55;
                cursor: not-allowed;
                background: ${colors.border3};
                color: ${colors.text3};
              }
            }

            select {
              border: 1px solid ${colors.border3};
              border-radius: 4px;
              padding: 8px 12px;
              font-size: 14px;
            }
          }
        }
      }
    }

    @media (max-width: 767px) {
      .testimonials-area {
        padding: 40px 0;

        .card-box {
          padding: 20px;
        }

        .actions {
          button {
            width: 100%;
          }
          .search-form {
            flex-direction: column;
            input {
              min-width: 100%;
            }
            button {
              width: 100%;
            }
          }
          .filter-controls {
            flex-direction: column;
            align-items: flex-start;

            select {
              width: 100%;
            }
          }
        }

        .data-grid {
          overflow-x: auto;
        }
      }
    }
  }
`;

export const TestimonialModalStyles = createGlobalStyle`
    .admin-testimonials-modal {
        .modal-content {
            border-radius: 10px;
            border: none;
            box-shadow: 0 20px 60px rgba(0,0,0,0.18);
        }

        .modal-header {
            border-bottom: 1px solid ${colors.border1};
            padding: 20px 24px;

            h5 {
                font-size: 18px;
                font-weight: 600;
                color: ${colors.black1};
            }
        }

        .modal-body {
            padding: 24px;
            background: ${colors.bg2};

            label {
                font-size: 14px;
                font-weight: 600;
                color: ${colors.black1};
            }

            input,
            textarea,
            select {
                font-size: 14px;
            }

            .gallery-picker {
                margin-top: 12px;
                display: flex;
                flex-direction: column;
                gap: 8px;

                .muted {
                    color: ${colors.text3};
                    font-size: 13px;
                }

                select {
                    font-size: 14px;
                }

                .gallery-status {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    color: ${colors.text3};
                    font-size: 13px;
                }
            }

            .avatar-preview {
                margin-top: 15px;

                .preview-label {
                    display: block;
                    font-size: 12px;
                    text-transform: uppercase;
                    color: ${colors.text3};
                    letter-spacing: 0.04em;
                    margin-bottom: 6px;
                }

                img {
                    max-width: 100%;
                    border-radius: 6px;
                    border: 1px solid ${colors.border1};
                    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
                }
            }
        }

        .modal-footer {
            border-top: 1px solid ${colors.border1};
            padding: 16px 24px;
        }
    }
`;
